import { parsePhoneNumberFromString } from 'libphonenumber-js';
import { zipCodePatterns } from './zipCodePatterns';

const validateEmptyValue = (input: string, fieldName = '', customErrorMessage?: string) => {
    const response = {
        status: 'true',
        error: '',
    };

    if (typeof input !== 'string') {
        throw new Error('Input must be a string');
    }

    if (input.trim() === '') {
        response.error = customErrorMessage || (fieldName ? `${fieldName} is required.` : 'This field is required.');
        response.status = 'false';
    }

    return response;
};

const validateUsername = (username: string, fieldName: string) => {

    const response = {
        "status": "true",
        "error": ""
    };
    const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    const alphabetPattern = /^[A-Za-z\s]+$/;

    if (!emailPattern.test(username) && !alphabetPattern.test(username)) {

        response["error"] = 'Please enter a valid ' + fieldName + '.';
        response["status"] = "false";

    }
    // console.log(response);
    return response;
};

const validateBusinessName = (username: string, fieldName: string) => {
   
    const response = {
        "status": "true",
        "error": ""
    };

    const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    const usernamePattern = /^[A-Za-z\s_'"-]+$/;

    if (!emailPattern.test(username) && !usernamePattern.test(username)) {
        response["error"] = 'Please enter a valid ' + fieldName + ' only.';
        response["status"] = "false";
    }

    // console.log(response);
    return response;
};

const validateEmail = (email: string, fieldName: string) => {

    const response = {
        "status": "true",
        "error": ""
    };
    const emailPattern = /^[a-z0-9._-]+@[a-z0-9.-]+\.[a-z]{2,4}$/;

    const trimmedEmail = email.trim();

    if (!emailPattern.test(trimmedEmail)) {

        response["error"] = 'Please enter a valid ' + fieldName + '.';
        response["status"] = "false";

    }
    // console.log(response);
    return response;
};

const validateMobileNumber = (number: string, countryCode: string, errorMessage: string) => {
    const response = {
        status: 'true',
        error: '',
    };

    if (!number) {
        response.error = 'Phone is required';
        response.status = 'false';
        return response;
    }

    // Remove any leading/trailing spaces from the number
    number = number.trim();

    if (number.includes(' ')) {
        response.error = 'Mobile number cannot contain spaces';
        response.status = 'false';
        return response;
    }

    // Check if the number contains only numeric characters and '+' symbol
    if (/\s|[^\d+]/.test(number)) {
        response.error = 'Mobile number must contain only numeric characters';
        response.status = 'false';
        return response;
    }

    number = String(countryCode) + String(number);

    // Parse the number using the parsing library
    const parsedPhoneNumber = parsePhoneNumberFromString(number);

    if (!parsedPhoneNumber || !parsedPhoneNumber.isValid()) {
        response.error = `${errorMessage}`;
        response.status = 'false';
        return response;
    }

    return response;
};


const validateOldPassword_NewPassword_ConfirmPassword = (oldPassword: string, newPassword: string, confirmPassword: string) => {
    const response = {
        status: "true",
        oldPasswordError: "",
        newPasswordError: "",
        confirmPasswordError: "",
    };

    const trimmedOldPassword = oldPassword.trim();
    const trimmedNewPassword = newPassword.trim();
    const trimmedConfirmPassword = confirmPassword.trim();

    const passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#^~/<>.,:;])[A-Za-z\d@$!%*?&#^~/<>.,:;]{8,}$/;

    if (trimmedOldPassword === '') {
        response["oldPasswordError"] = 'Old password is required';
        response["status"] = "false";
    } else if (!passwordPattern.test(trimmedOldPassword)) {
        response["oldPasswordError"] = 'Old password must have at least 8 characters, including uppercase, lowercase, and numbers.';
        response["status"] = "false";
    }

    if (trimmedNewPassword === '') {
        response["newPasswordError"] = 'New password is required';
        response["status"] = "false";
    } else if (!passwordPattern.test(trimmedNewPassword)) {
        response["newPasswordError"] = 'New password must have at least 8 characters, including uppercase, lowercase, and numbers.';
        response["status"] = "false";
    }

    if (trimmedConfirmPassword === '') {
        response["confirmPasswordError"] = 'Confirm password is required';
        response["status"] = "false";
    } else if (!passwordPattern.test(trimmedConfirmPassword)) {
        response["confirmPasswordError"] = 'Confirm password must have at least 8 characters, including uppercase, lowercase, and numbers.';
        response["status"] = "false";
    } else if (trimmedNewPassword !== trimmedConfirmPassword) {
        response["confirmPasswordError"] = 'Passwords do not match';
        response["status"] = "false";
    }

    // console.log(response);
    return response;
};

const validatePassword = (password: string) => {

    const response = {
        "status": "true",
        "error": ""
    };
    const passwordRules = [
        (password: string) => password.length >= 8,
        (password: string) => /[A-Z]/.test(password),
        (password: string) => /[a-z]/.test(password),
        (password: string) => /[0-9]/.test(password),
        (password: string) => /[!@#$%^&*()_+{}[\]:;<>,.?~\\-]/.test(password),
    ];

    for (const rule of passwordRules) {
        if (!rule(password)) {
            response["error"] = 'Incorrect password.';
            response["status"] = "false";
        }
    };
    // console.log(response);
    return response;
};

const validatePassword_ConfirmPassword = (newPassword: string, confirmPassword: string, fieldName?: string) => {
    const response = {
        status: "true",
        newPasswordError: "",
        confirmPasswordError: "",
    };

    const trimmedNewPassword = newPassword.trim();
    const trimmedConfirmPassword = confirmPassword.trim();

    const passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#^~/<>.,:;])[A-Za-z\d@$!%*?&#^~/<>.,:;]{8,}$/;


    if (trimmedNewPassword === '') {
        response["newPasswordError"] = 'Password is required';
        response["status"] = "false";
    } else if (!passwordPattern.test(trimmedNewPassword)) {
        response["newPasswordError"] = 'Password must have at least 8 characters, including uppercase, lowercase, and numbers.';
        response["status"] = "false";
    }

    if (trimmedConfirmPassword === '') {
        response["confirmPasswordError"] = 'Confirm password is required';
        response["status"] = "false";
    } else if (!passwordPattern.test(trimmedConfirmPassword)) {
        response["confirmPasswordError"] = 'Confirm password must have at least 8 characters, including uppercase, lowercase, and numbers.';
        response["status"] = "false";
    } else if (trimmedNewPassword !== trimmedConfirmPassword) {
        response["confirmPasswordError"] = 'Passwords do not match';
        response["status"] = "false";
    }
    return response;
};

const validatepassword_ConfirmPassword = (password: string, confirmPassword: string, fieldName: string) => {

    const response = {
        status: "true",
        passworderror: "",
        confirm_passworderror: "",
    };

    const passwordRules = [
        (password: string) => password.length >= 8,
        (password: string) => /[A-Z]/.test(password),
        (password: string) => /[a-z]/.test(password),
        (password: string) => /[0-9]/.test(password),
        (password: string) => /[!@#$%^&*()_+{}[\]:;<>,.?~\\-]/.test(password),
    ];

    if (password.trim() === '' || confirmPassword.trim() === '') {
        response["passworderror"] = password.trim() === '' ? 'Password is required' : '';
        response["confirm_passworderror"] = confirmPassword.trim() === '' ? 'Confirm password is required' : '';
        response["status"] = "false";
    } else {

        let passwordValid = true
        for (const rule of passwordRules) {
            if (!rule(password)) {
                passwordValid = false;
                break;
            }
        };

        if (!passwordValid) {
            response["passworderror"] = "Password must be at least 8 characters long, contain at least one number, and have a mixture of uppercase and lowercase letters with a special character.";
            response["status"] = "false";
        } else if (password !== confirmPassword) {
            response["confirm_passworderror"] = 'Passwords do not match';
            response["status"] = "false";
        };
    };
    // console.log(response);
    return response;
};

const validateDropdown_RelationShip = (selectedItem: string, fieldName: string,): { status: string; error: string; } => {
    const response = {
        status: "true",
        error: "",
        OtherRelationship_error: ""
    };

    /**
    * Function to Validate other relationship 
    * @param String selectionRelationship, otherRelationship
    * @returns object key and boolean value
    */

    if (selectedItem === '') {
        response["error"] = fieldName + ' is required.';
        response["status"] = "false";

    } else {
        response["error"];
        response["status"];
    }
    // console.log(response);
    return response;
};

const validateDropdown = (selectedItem: string, fieldName: string) => {
    const response = {
        status: "true",
        error: ""
    };
    if (selectedItem === '') {
        response["error"] = 'Please select a ' + fieldName;
        response["status"] = "false";

    } else {
        response['error'] = '';
        response['status'] = 'true';
    };
    // console.log(response);
    return response;
};

const validateEmptyValuenumber = (value: any, fieldName: any) => {
    if (!value) {
        return { status: 'false', error: `${fieldName} cannot be empty` };
    }
    return { status: 'true' };
};

const validateOTP = (value: any, fieldName: any) => {
    const otpPattern = /^[0-9]{6}$/;
    if (!otpPattern.test(value)) {
        return { status: 'false', error: `${fieldName} is invalid` };
    }
    return { status: 'true' };
};

const validateAddress = (address: string, fieldName: string) => {
    const response = {
        status: "true",
        error: ""
    };
    const addressPattern = /^[a-zA-Z0-9\s,'#./-]+$/;

    if (!addressPattern.test(address)) {
        response["error"] = 'Please enter a valid ' + fieldName + ' only.';
        response["status"] = "false";
    };
    // console.log(response);
    return response;
};


const validateZipCodeByCountry = (country: string, zipCode: string) => {

    const response = {
        status: "true",
        error: ""
    };

    const trimmedZipCode = zipCode.trim();
    if (country) {

        const countryZipCodePattern = zipCodePatterns[country];

        if (!trimmedZipCode) {
            response.error = 'Zip code is required';
            response.status = 'false';
        } else if (!countryZipCodePattern) {
            response.error = 'Zip code validation not available for this country';
            response.status = 'false';
        } else if (!countryZipCodePattern.test(trimmedZipCode)) {
            response.error = 'Invalid zip code for the selected country';
            response.status = 'false';
        }
    } else {

        if (!trimmedZipCode) {
            response.error = 'Zip code is required';
            response.status = 'false';
        }
    }
    return response;
};


const validateURL = (url: string, fieldName: string) => {
    const response = {
        status: "true",
        error: ""
    };

    const urlRegPattern = /^(https?:\/\/)?(www\.)?([a-zA-Z0-9-_]+(\.[a-zA-Z0-9-_]+)+)+[a-zA-Z]{2,}(\/[a-zA-Z0-9#?&=%_./-]*)?$/;

    if (!urlRegPattern.test(url)) {
        response.error = `Please enter a valid ${fieldName}.`;
        response.status = "false";
    }

    return response;
};

const validateServicename = (servicename: string, fieldName: string) => {

    const response = {
        "status": "true",
        "error": ""
    };

    const alphabetPattern = /^[A-Za-z0-9\s!@#$%^&*()-_=+{}|\\[\];:'",.<>/?]+$/;

    if (servicename.trim() === '') {

        response.error = fieldName ? `${fieldName} is required.` : 'This field is required.';
        response.status = 'false';
    } else if (!alphabetPattern.test(servicename)) {

        response["error"] = 'Please enter a valid ' + fieldName + '.';
        response["status"] = "false";

    }
    // console.log(response);
    return response;
};

const validateServiceDates = (startDate: string | Date, endDate: string | Date) => {

    const response = {
        status: "true",
        error: ""
    };

    if (startDate && endDate) {
        if (startDate > endDate) {
            response.status = "false";
            response.error = "End date should be greater than start date";
        }
    }
    return response;
};

const validateImageUpload = (imageUpload: any) => {

    const response = {
        "status": "true",
        "error": ""
    };

    if (!imageUpload) {

        response["error"] = 'Please upload a photo';
        response["status"] = "false";
    } else {
        response['error'] = '';
        response['status'] = 'true';
    }
    // console.log(response);
    return response;
};

export {
    validateEmptyValue,
    validateUsername,
    validateEmail,
    validateMobileNumber,
    validateOldPassword_NewPassword_ConfirmPassword,
    validateDropdown_RelationShip,
    validateDropdown,
    validatePassword_ConfirmPassword,
    validateEmptyValuenumber,
    validateOTP,
    validateAddress,
    validateZipCodeByCountry,
    validateURL,
    validatePassword,
    validatepassword_ConfirmPassword,
    validateServicename,
    validateServiceDates,
    validateImageUpload,
    validateBusinessName
};